export const adminuserConstants = {
    GETADMINUSER_REQUEST: "GETADMINUSER_REQUEST",
    GETADMINUSER_SUCCESS: "GETADMINUSER_SUCCESS",
    GETADMINUSER_FAILURE: "GETADMINUSER_FAILURE",
    GETADMINUSER_SHOW: "GETADMINUSER_SHOW",
    GETDEALERS_SUCCESS: "GETDEALERS_SUCCESS"
  };
  